import Reports from '@/pages/Reports';

export default function MobileReportsScreen() {
  return <Reports />;
}

